import $ from "jquery";

const productArchiveWithBrand = () => {
  const target = {
    body: "body.archive.woocommerce",
    divider: ".archive-brand__divider",
    title: ".archive-brand__title",
    container: ".archive-brand__container",
    item: ".mi-brand-category__item",
  };
  const $body = $(target.body);
  const $divider = $(target.divider);
  const $title = $(target.title);
  const $container = $(target.container);
  const $item = $(target.item);

  const init = () => {
    $(document).ready(function () {
      if ($body.length) {
        exec();
      }
    });
  };
  const exec = () => {
    if (!$item.length) {
      $divider.hide();
      $title.hide();
      $container.hide();
    }
  };
  init();
};

try {
  productArchiveWithBrand();
} catch (error) {
  throw Error(error);
}
